function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { ChangeEventHandler, FC, Fragment } from 'react';
import cn from 'classnames';
require("./RatingInput.css");
var styles = {
  "RatingInput": "RatingInput-module-RatingInput_3Ss",
  "Input": "RatingInput-module-Input_2dI",
  "Label": "RatingInput-module-Label_3St"
};
import { IRatingBaseProps } from '../Rating';
const defaultValues = [{
  title: 'Отлично',
  value: 5
}, {
  title: 'Хорошо',
  value: 4
}, {
  title: 'Нормально',
  value: 3
}, {
  title: 'Плохо',
  value: 2
}, {
  title: 'Ужасно',
  value: 1
}];
const noop = () => {};
const hash = (Math.random() + 1).toString(36).substring(5);
export const RatingInput = ({
  values = defaultValues,
  onChange = noop,
  value,
  className,
  style,
  innerRef,
  controlRef,
  tag: Component = 'fieldset',
  ...props
}) => {
  value = Math.min(value, defaultValues.length);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cn(styles.RatingInput, className),
    ref: innerRef || controlRef
  }, props), values.map(input => {
    const id = input.value + hash;
    const checked = value === input.value;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: id
    }, /*#__PURE__*/React.createElement("input", {
      className: cn(styles.Input),
      checked: checked,
      type: "radio",
      id: id,
      name: hash,
      value: input.value,
      onChange: onChange
    }), /*#__PURE__*/React.createElement("label", {
      className: cn(styles.Label),
      htmlFor: id
    }, input.title));
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RatingInput.displayName = 'RatingInput';
}